export default {
  path: '/nozzles',
  name: 'nozzles',
  component: () => import('../components/nozzle/Layout'),
  redirect: { name: 'NozzleList' },
  meta: {
    breadcrumb: 'nozzle.nozzles',
  },
  children: [
    {
      name: 'NozzleList',
      path: '',
      component: () => import('../views/nozzle/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleCreate',
      path: 'new',
      component: () => import('../views/nozzle/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzle/Update'),
      meta: {
        breadcrumb: 'nozzle.nozzle',
      },
    },
    {
      name: 'NozzleShow',
      path: ':id',
      component: () => import('../views/nozzle/Show'),
      meta: {
        breadcrumb: 'nozzle.nozzle',
      },
    }
  ]
};
